
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.94 33.59"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Laag_2","data-name":"Laag 2"}},[_c('g',{attrs:{"id":"Laag_1-2","data-name":"Laag 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M21.39 16.8h-.74v1.53h.74a.76.76 0 00.73-.77.75.75 0 00-.73-.76"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M21.39 19.85h-.74v2.29a.74.74 0 11-1.48 0V16a.75.75 0 01.74-.77h1.48a2.29 2.29 0 010 4.58m-3.69 2.33a.74.74 0 11-1.48 0V16a.74.74 0 111.48 0zm-2.26-5.83l-2.22 6.1a.73.73 0 01-.69.5.75.75 0 01-.69-.5l-2.21-6.1a.78.78 0 01.43-1 .74.74 0 01.95.45L12.19 19c.19.52.5.52.68 0l1.19-3.26a.74.74 0 01.95-.45.78.78 0 01.43 1m18.46-3.56a.76.76 0 00-.6-.51l-6.73-.92a8.32 8.32 0 01-5.7-4.15L17.63.42A.74.74 0 0017 0a.73.73 0 00-.66.42l-3.28 6.73a8.32 8.32 0 01-5.7 4.15l-6.72.92a.75.75 0 00-.6.51.79.79 0 00.18.79l5.05 5.23a8.58 8.58 0 012 6.8l-1.35 7.12a.79.79 0 00.27.76.74.74 0 00.81.07l6.45-3.33a8.62 8.62 0 017.1 0L27 33.5a.64.64 0 00.33.08.69.69 0 00.45-.15.78.78 0 00.27-.76l-1.37-7.12a8.59 8.59 0 012-6.8l5.06-5.23a.81.81 0 00.17-.79"}})])])])
          )
        }
      }
    